(function () {
    'use strict';

    angular
        .module('surveyControllers')
        .controller('SurveyRespondentPageController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'surveyService', 'surveyContextService', 'survey', 'page'];

    function Controller($scope, $state, topBarService, surveyService, surveyContext, survey, page) {
        if (page.IsComplete) {
            $state.go('survey.forRespondent.completed', {}, {location: 'replace'});
            return;
        }

        topBarService.setTitleAndIcon(survey.Campaign.TitleEN, 'fa fa-bullhorn');

        $scope.surveyContext             = surveyContext;
        $scope.campaignAvailability      = page.Availability;
        $scope.campaignPart              = getCampaignPart();
        $scope.questions                 = getQuestions();
        $scope.previousPage              = {};
        $scope.nextPage                  = {};
        $scope.isLoadingPage             = false;
        $scope.isShowMissingInfoToSubmit = false;

        getPreviousAndNextPages();

        // Add Response
        $scope.addResponse = function (question, questionResponse) {
            surveyContext.IsUpdatingAnswer           = true;
            surveyContext.LastUpdatedAnswerTimestamp = null;

            return surveyService
                .addResponse(survey.Campaign.SlugObject,
                    question.CampaignPartID,
                    question.CampaignComponentID,
                    questionResponse)
                .then(function (savedResponse) {
                    $scope.campaignAvailability              = savedResponse.Availability;
                    surveyContext.IsUpdatingAnswer           = false;
                    surveyContext.LastUpdatedAnswerTimestamp = new Date().toISOString();

                    return savedResponse;
                });
        };

        // Remove Response
        $scope.removeResponse = function (question, questionResponse) {
            surveyContext.IsUpdatingAnswer           = true;
            surveyContext.LastUpdatedAnswerTimestamp = null;

            return surveyService.deleteResponse(survey.Campaign.SlugObject,
                question.CampaignPartID,
                question.CampaignComponentID,
                questionResponse);
        };

        // Is Navigation disabled
        $scope.isNavigationDisabled = function () {
            return surveyContext.IsUpdatingAnswer || $scope.isLoadingPage;
        };

        // Go To Previous Page
        $scope.goToPreviousPage = function () {
            if (!$scope.previousPage.PageNumber) {
                return;
            }

            $scope.isLoadingPage = true;
            $state.go('survey.forRespondent.page', {PageNumber: $scope.previousPage.PageNumber}, {reload: true});
        };

        // Go To Next Page
        $scope.goToNextPage = function () {
            if (!$scope.nextPage.PageNumber) {
                return;
            }

            $scope.isLoadingPage = true;
            $state.go('survey.forRespondent.page', {PageNumber: $scope.nextPage.PageNumber}, {reload: true});
        };

        // Show Submit Button
        $scope.showSubmitBtn = function () {
            return $scope.campaignAvailability.IsReadyForSubmit;
        };

        // Submit Survey
        $scope.submitSurvey = function () {
            surveyService
                .submitSurvey(survey.Campaign.SlugObject)
                .then(function (isSuccessful) {
                    if (isSuccessful === true) {
                        $state.go('survey.forRespondent.completed', {}, {reload: true});
                    } else {
                        // Display a message that there are missing info and show a button to get there
                        $scope.isShowMissingInfoToSubmit = true;
                    }
                });
        };

        // Go to next page with unanswered questions
        $scope.goToNextSurveyPageToProcess = function () {
            surveyService
                .getNextPageToProcess(survey.Campaign.SlugObject)
                .then(function (nextpageToProcess) {
                    if (nextpageToProcess.PageNumber === page.PageNumber) {
                        $scope.isShowMissingInfoToSubmit = false;
                    } else {
                        $state.go('survey.forRespondent.page', { PageNumber: nextpageToProcess.PageNumber });
                    }
                });
        };

        // Helpers
        function getPreviousAndNextPages() {
            surveyService
                .getPreviousPage(survey.Campaign.SlugObject, page)
                .then(function (previousPage) {
                    $scope.previousPage = previousPage;
                });

            surveyService
                .getNextPage(survey.Campaign.SlugObject, page)
                .then(function (nextPage) {
                    $scope.nextPage = nextPage;
                });
        }

        function getCampaignPart() {
            return page.PageNumber ? _.find(survey.Parts, {CampaignPartID: page.PageContents[0].CampaignPartID}) : null;
        }

        function getQuestions() {
            if (!page.PageContents || page.PageContents.length === 0) {
                return [];
            }
            return _.map(page.PageContents, function (component) {
                return $scope.campaignPart.QuestionsByID[component.ComponentID];
            });
        }
    }
})();